import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "./Header";
import PageTransition from "./PageTransition";
import DiscountPopup from "@/components/home/DiscountPopup";

const Footer = lazy(() => import("@/components/layout/Footer"));
const ScriptAuditPanel = lazy(() => import("@/components/dev/ScriptAuditPanel"));

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const showAudit =
    isHome &&
    (import.meta.env.DEV ||
      (typeof window !== "undefined" &&
        new URLSearchParams(window.location.search).has("audit")));

  return (
    <div className="min-h-screen bg-background">
      <Header transparentOnTop={isHome} />
      <AnimatePresence mode="wait">
        <PageTransition key={location.pathname}>
          {children}
        </PageTransition>
      </AnimatePresence>
      <Suspense fallback={<div className="h-96" aria-hidden="true" />}>
        <Footer />
      </Suspense>
      {isHome && <DiscountPopup />}
      {showAudit && (
        <Suspense fallback={null}>
          <ScriptAuditPanel />
        </Suspense>
      )}
    </div>
  );
};

export default Layout;
